module.exports = __webpack_public_path__ + "img/6.e49b7b46.png";